import React, { memo } from "react";
import { AreaChart, Area } from "recharts";

type AreaChartProps = {
  width: number;
  height: number;
  data: { x: number; y: number }[];
  chartProgress: boolean;
  isNeutral: boolean;
};
enum GREEN {
  TOP = "rgb(165, 199, 54)",
  BOTTOM = "rgba( 28, 29, 32, 0)",
}

enum RED {
  TOP = "rgb(238, 88, 73)",
  BOTTOM = "rgba( 28, 29, 32, 0)",
}

enum WHITE {
  TOP = "white",
  BOTTOM = "white",
}

const AreaChartMini = (props: AreaChartProps) => {
  return (
    <AreaChart
      width={props.width}
      height={props.height}
      data={props.data}
      margin={{ top: 5, right: 0, left: 0, bottom: 1 }}
    >
      <defs>
        <linearGradient id={`colorUv${props.chartProgress}-${props.isNeutral}`} x1="0" y1="0" x2="0" y2="1">
          <stop
            offset="5%"
            stopColor={props.isNeutral ? WHITE.TOP : props.chartProgress ? GREEN.TOP : RED.TOP}
            stopOpacity={0.8}
          />
          <stop
            offset="95%"
            stopColor={props.isNeutral ? WHITE.TOP : props.chartProgress ? GREEN.TOP : RED.TOP}
            stopOpacity={0.09}
          />
        </linearGradient>
      </defs>

      <Area
        type="monotone"
        dataKey="y"
        stroke={props.isNeutral ? WHITE.TOP : props.chartProgress ? GREEN.TOP : RED.TOP}
        fillOpacity={1}
        fill={`url(#colorUv${props.chartProgress}-${props.isNeutral})`}
      />
    </AreaChart>
  );
};

export default memo(AreaChartMini);
